import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import classnames from "classnames";
import { WalletItemProps } from "./types";
import { getWalletTranslationKey } from "@utils";
import { UserAccountType } from "@common/constants";
import AccountTypeSelector from "./AccountTypeSelector";

export default observer(function WalletItem(props: WalletItemProps) {
	const { wallet, isInMenu, numberOfWallets } = props;

	if (
		!wallet ||
		(wallet.abrv === UserAccountType.SportBettingAccountShop && !isInMenu)
	) {
		return null;
	}

	const iconClasses = classnames(
		"wallet__icon",
		{
			"wallet--sml__icon": !isInMenu,
		},
		"u-icon",
		{
			"u-icon--tny": !isInMenu,
			"u-icon--sml": isInMenu,
		},
		[`u-icon--wallet u-icon--wallet--${wallet.abrv}`]
	);

	return (
		<li
			className={classnames("usermenu__wallets__item", {
				"usermenu__wallets--sml__item": !isInMenu,
			})}
		>
			<div
				className={classnames("wallet input--radio", {
					"input--radio--sml": isInMenu,
					"wallet--sml input--radio--tny": !isInMenu,
					"is-disabled":
						numberOfWallets == 1 ||
						("canBeSelected" in wallet &&
							wallet.canBeSelected == false) ||
						!isInMenu,
					"is-hidden": numberOfWallets == 1 && isInMenu,
				})}
			>
				<AccountTypeSelector
					isInMenu={isInMenu}
					wallet={wallet}
					numberOfWallets={numberOfWallets}
				/>

				<label
					htmlFor={!isInMenu ? `${wallet.id}` : `${wallet.id}-menu`}
					className={classnames(
						[
							`wallet__account wallet__account--${wallet.abrv} input--radio__label`,
						],
						{
							"input--radio--sml__label": isInMenu,
							"wallet--sml__account input--radio--tny__label":
								!isInMenu,
							"is-disabled":
								numberOfWallets == 1 ||
								("canBeSelected" in wallet &&
									wallet.canBeSelected == false) ||
								!isInMenu,
						}
					)}
				>
					<span
						className={classnames("wallet__name", {
							"wallet--sml__name": !isInMenu,
						})}
					>
						{numberOfWallets != 1 && <i className={iconClasses} />}
						<>
							<WalletName
								isInMenu={isInMenu}
								wallet={wallet}
								numberOfWallets={numberOfWallets}
							/>
							:
						</>
					</span>
					<span
						data-id={wallet.id}
						className={classnames("wallet__balance", {
							"wallet--sml__balance": !isInMenu,
						})}
					>
						<>
							{wallet.balance.toFixed(2)}{" "}
							{wallet.currency.displayCode}
						</>
					</span>
				</label>
			</div>
		</li>
	);
});

function WalletName(props: WalletItemProps) {
	const { numberOfWallets, wallet } = props;
	const { t } = useTranslation("account-settings-navigation");

	if (numberOfWallets == 1) {
		return <>{t<string>(`account-settings-navigation:ACCOUNT_BALANCE`)}</>;
	}
	return <>{t<string>(getWalletTranslationKey(wallet.abrv))}</>;
}
